import React, { createContext, useContext, useState } from "react";

interface ChatContextType {
  isVisible: boolean;
  selectedChat: {
    id: string;
    name: string;
    avatar?: string;
    status: "online" | "offline" | "away";
    isGroup: boolean;
  } | null;
  toggleChat: () => void;
  selectChat: (chat: {
    id: string;
    name: string;
    avatar?: string;
    status: "online" | "offline" | "away";
    isGroup: boolean;
  }) => void;
  closeChat: () => void;
}

const ChatContext = createContext<ChatContextType | undefined>(undefined);

export function ChatProvider({ children }: { children: React.ReactNode }) {
  const [isVisible, setIsVisible] = useState(false);
  const [selectedChat, setSelectedChat] =
    useState<ChatContextType["selectedChat"]>(null);

  const toggleChat = () => {
    setIsVisible(!isVisible);
  };

  const selectChat = (chat: ChatContextType["selectedChat"]) => {
    setSelectedChat(chat);
    setIsVisible(true);
  };

  const closeChat = () => {
    setIsVisible(false);
    setSelectedChat(null);
  };

  return (
    <ChatContext.Provider
      value={{ isVisible, selectedChat, toggleChat, selectChat, closeChat }}
    >
      {children}
    </ChatContext.Provider>
  );
}

export function useChat() {
  const context = useContext(ChatContext);
  if (context === undefined) {
    throw new Error("useChat must be used within a ChatProvider");
  }
  return context;
}